import SimpleAudioPlayer from './simple-audio-player'

export default function LandingAudioPreview() {
	return (
		<section id="audio-preview" className="relative px-6 py-32">
			<div className="relative mx-auto max-w-6xl">
				<div className="mb-16 text-center">
					<h2 className="text-foreground mb-6 text-5xl font-extrabold tracking-tight md:text-6xl">
						Hear the{' '}
						<span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
							Difference
						</span>
					</h2>
					<p className="text-base-content/80 mx-auto max-w-2xl text-xl md:text-2xl">
						Hear how Podly turns raw audio into a polished, professional episode
					</p>
				</div>
				<div className="grid gap-12 md:grid-cols-2">
					{/* Before Audio */}
					<div className="group border-foreground/20 bg-background/50 rounded-3xl border p-4 backdrop-blur-sm transition-all duration-300 hover:border-indigo-400/50 hover:shadow-2xl hover:shadow-indigo-500/20">
						<h3 className="text-foreground mb-4 text-2xl font-bold md:text-3xl">
							Before Processing
						</h3>
						<p className="text-base-content/70 mb-6 text-base md:text-lg">
							Original audio with background noise and imperfections
						</p>
						<SimpleAudioPlayer audioUrl="/audio/Broadcast 11-17.wav" />
					</div>
					{/* After Audio */}
					<div className="group rounded-3xl border-2 border-indigo-400/30 bg-gradient-to-br from-indigo-500/10 to-purple-500/10 p-4 backdrop-blur-sm transition-all duration-300 hover:border-indigo-400/60 hover:shadow-2xl hover:shadow-indigo-500/30">
						<h3 className="text-foreground mb-4 text-2xl font-bold md:text-3xl">
							After Processing
						</h3>
						<p className="text-base-content/70 mb-6 text-base md:text-lg">
							Enhanced audio with noise reduction and professional polish
						</p>
						<SimpleAudioPlayer audioUrl="/audio/Broadcast 11-17-processed.wav" />
					</div>
				</div>
			</div>
		</section>
	)
}
